import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "nav-datepicker nav-item" };
const _hoisted_2 = {
    key: 0,
    class: "disabled"
};
const _hoisted_3 = { class: "text" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "text" };
import { datepickerLanguage, datepickerUpdate } from '@/helpers/setup-datepicker';
import { useStore } from 'vuex';
import { h, shallowRef, computed, ref, onMounted, watch } from 'vue';
import { useMixpanelConfig, useMixpanelDatepicker, useMixpanelDatepickerPanelLinks } from '@/utilities/mixpanel';
import moment from 'moment';
import { dateFormat } from '@/utilities/constants';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeaderDatepickerEmailCampaign',
    props: {
        language: {},
        allowCurrentDay: { type: Boolean, default: false },
        removeShortcutIds: { default: () => [] },
        defaultShortcutId: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const customPrefix = shallowRef({
            render() {
                return h('i', {
                    class: 'icon icon-calendar-30px',
                });
            },
        });
        const datepickerStartDate = ref('');
        const datepickerEndDate = ref('');
        const isProcessingCurrentDay = ref(false);
        const NAME_EVENT_MIXPANEL = `_${String(router.currentRoute.value.name)}`;
        const getDates = computed(() => store.getters['dates']);
        const getShortcuts = computed(() => {
            const allShortcuts = datepickerLanguage(props.language).el.shortcuts;
            const filteredShortcuts = allShortcuts.filter(shortcut => !props.removeShortcutIds?.includes(shortcut.key));
            const result = filteredShortcuts.map(item => ({
                text: item.text,
                value() {
                    const dates = {
                        startDate: item.value[0]['_d'],
                        endDate: item.value[1]['_d'],
                    };
                    useMixpanelDatepickerPanelLinks(`view${NAME_EVENT_MIXPANEL}_click_link_sidebar_datepicker`, item.text, dates);
                    return item.value;
                },
            }));
            return result;
        });
        // Calcula o range de datas permitido com base nos shortcuts disponíveis
        const getMaxDateRange = computed(() => {
            const allShortcuts = datepickerLanguage(props.language).el.shortcuts;
            const filteredShortcuts = allShortcuts.filter(shortcut => !props.removeShortcutIds?.includes(shortcut.key));
            if (filteredShortcuts.length === 0) {
                return { minDate: null, maxDate: null };
            }
            let minDate = moment();
            filteredShortcuts.forEach(shortcut => {
                const startDate = moment(shortcut.value[0]);
                if (startDate.isBefore(minDate)) {
                    minDate = startDate;
                }
            });
            const maxDate = moment();
            return {
                minDate: minDate.startOf('day'),
                maxDate: maxDate.endOf('day'),
            };
        });
        const datepickerValue = computed({
            get() {
                const dates = {
                    startDate: getDates?.value?.startDate,
                    endDate: getDates?.value?.endDate,
                };
                return [dates.startDate, dates.endDate];
            },
            set(newDate) {
                useMixpanelDatepicker(`view${NAME_EVENT_MIXPANEL}_select_datepicker`, newDate[0], newDate[1]);
                datepickerUpdate(newDate);
            },
        });
        const openMixPanel = () => {
            useMixpanelConfig(`view${NAME_EVENT_MIXPANEL}_open_datepicker`);
        };
        const disableFutureDatesForEmailCampaign = (time) => {
            const firstDateSelected = datepickerStartDate.value;
            const secondDateSelected = datepickerEndDate.value;
            const today = moment().startOf('day');
            const todayFormatted = today.format(dateFormat);
            const dateRange = getMaxDateRange.value;
            // Bloqueia datas fora do range permitido pelos shortcuts disponíveis
            if (dateRange.minDate && dateRange.maxDate) {
                const timeStartOfDay = moment(time).startOf('day');
                if (timeStartOfDay.isBefore(dateRange.minDate) || timeStartOfDay.isAfter(dateRange.maxDate)) {
                    return true;
                }
            }
            // Validações quando a primeira data já foi selecionada
            if (firstDateSelected && !secondDateSelected) {
                const timeFormatted = moment(time).format(dateFormat);
                // Regras específicas para allowCurrentDay
                if (!props.allowCurrentDay) {
                    if (firstDateSelected === todayFormatted) {
                        return timeFormatted !== todayFormatted;
                    }
                    if (firstDateSelected < todayFormatted && timeFormatted === todayFormatted) {
                        return true;
                    }
                }
            }
            return false;
        };
        const calendarWatchEmailCampaign = (date) => {
            const today = moment().format(dateFormat);
            const firstDate = moment(date[0]).format(dateFormat);
            const secondDate = date[1] !== null ? moment(date[1]).format(dateFormat) : null;
            datepickerStartDate.value = firstDate;
            if (date[1] !== null) {
                datepickerEndDate.value = secondDate;
            }
            if (!props.allowCurrentDay) {
                if (firstDate === today && date[1] === null) {
                    isProcessingCurrentDay.value = true;
                    datepickerEndDate.value = today;
                    datepickerUpdate([today, today]);
                    setTimeout(() => {
                        isProcessingCurrentDay.value = false;
                    }, 100);
                    return;
                }
                if (secondDate !== null && (firstDate === today || secondDate === today)) {
                    isProcessingCurrentDay.value = true;
                    datepickerStartDate.value = today;
                    datepickerEndDate.value = today;
                    datepickerUpdate([today, today]);
                    setTimeout(() => {
                        isProcessingCurrentDay.value = false;
                    }, 100);
                    return;
                }
            }
        };
        const clearStartDate = (visible) => {
            if (visible) {
                datepickerStartDate.value = '';
                datepickerEndDate.value = '';
                datepickerValue.value = ['', ''];
            }
        };
        // Função para aplicar o shortcut padrão
        const applyDefaultShortcut = () => {
            if (props.defaultShortcutId) {
                const allShortcuts = datepickerLanguage(props.language).el.shortcuts;
                const defaultShortcut = allShortcuts.find(shortcut => shortcut.key === props.defaultShortcutId);
                if (defaultShortcut) {
                    const startDate = moment(defaultShortcut.value[0]).format(dateFormat);
                    const endDate = moment(defaultShortcut.value[1]).format(dateFormat);
                    datepickerUpdate([startDate, endDate]);
                }
            }
        };
        // Observa mudanças no defaultShortcutId para aplicar automaticamente
        watch(() => props.defaultShortcutId, newShortcutId => {
            if (newShortcutId) {
                applyDefaultShortcut();
            }
        }, { immediate: true });
        // Aplica o período padrão ao montar o componente
        onMounted(() => {
            applyDefaultShortcut();
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_el_date_picker = _resolveComponent("el-date-picker");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_date_picker, {
                    "popper-class": "custom-datepicker",
                    modelValue: datepickerValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((datepickerValue).value = $event)),
                    type: "daterange",
                    format: "DD/MM/YYYY",
                    "value-format": "YYYY-MM-DD",
                    clearable: false,
                    shortcuts: getShortcuts.value,
                    editable: false,
                    disabled: isProcessingCurrentDay.value,
                    "disabled-date": disableFutureDatesForEmailCampaign,
                    "prefix-icon": customPrefix.value,
                    onFocus: openMixPanel,
                    onCalendarChange: calendarWatchEmailCampaign,
                    onVisibleChange: clearStartDate
                }, {
                    default: _withCtx((cell) => [
                        (disableFutureDatesForEmailCampaign(cell?.date))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_el_popover, {
                                    trigger: "hover",
                                    placement: "top",
                                    width: 170
                                }, {
                                    reference: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(cell.text), 1)
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('datepicker-disabled-dates-tooltip')), 1)
                                    ]),
                                    _: 2
                                }, 1024)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(cell.text), 1)
                            ]))
                    ]),
                    _: 1
                }, 8, ["modelValue", "shortcuts", "disabled", "prefix-icon"])
            ]));
        };
    }
});
